import { DashboardModuleConfiguration } from '@dreryk/egabinet-dashboard-frontend-api';

export const dashboardModuleChipVisitor = (dashboardModuleConfiguration: DashboardModuleConfiguration | null) => <
   ACCEPT
>(variant: {
   visitPsychiatricModuleChip: () => ACCEPT;
   visitNeurologicalModuleChip: () => ACCEPT;
}) => {
   if (!dashboardModuleConfiguration) {
      return null;
   }

   if (dashboardModuleConfiguration.neurologicalModuleEnabled) {
      return variant.visitNeurologicalModuleChip();
   }

   if (dashboardModuleConfiguration.psychiatricModuleEnabled) {
      return variant.visitPsychiatricModuleChip();
   }

   return null;
};
